import React from 'react';
import { Package, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { spareCategories } from '../mockData';

const Spares = () => {
  return (
    <section id="spares" className="py-20 bg-gradient-to-br from-[#2E3C5B] via-[#1f2a3f] to-[#2E3C5B] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#E94B3C] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#E94B3C] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="relative group order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1709102884400-b50ca1a12bc3"
                alt="Laptop spare parts"
                className="w-full h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2E3C5B]/90 via-transparent to-transparent"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#E94B3C] rounded-2xl -z-10 group-hover:rotate-6 transition-transform duration-500"></div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div className="space-y-4">
              <div className="inline-block bg-[#E94B3C] px-4 py-2 rounded-full text-sm font-semibold">
                GENUINE PARTS
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                Looking for Laptop Spare Parts?
              </h2>
              
              <div className="w-24 h-1 bg-[#E94B3C] rounded-full"></div>
              
              <p className="text-xl text-gray-200 leading-relaxed">
                We stock a comprehensive range of genuine laptop spare parts for all major brands. From screens to motherboards, we have everything you need.
              </p>
            </div>

            {/* Categories Grid */}
            <div className="grid grid-cols-2 gap-4">
              {spareCategories.map((category, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 hover:bg-white/20 hover:border-[#E94B3C] transition-all duration-300 cursor-pointer group/item"
                >
                  <div className="flex items-center gap-3">
                    <Package className="text-[#E94B3C] group-hover/item:scale-110 transition-transform" size={20} />
                    <span className="font-medium">{category}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Features */}
            <div className="space-y-3 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full"></div>
                <p className="text-gray-200">100% Original manufacturer parts</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full"></div>
                <p className="text-gray-200">Same-day delivery available in major cities</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full"></div>
                <p className="text-gray-200">Expert installation service included</p>
              </div>
            </div>

            {/* CTA Button */}
            <Button
              size="lg"
              className="bg-[#E94B3C] hover:bg-[#d43d2c] text-white border-0 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 group"
            >
              Browse All Spares
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Spares;
